// extracted by mini-css-extract-plugin
module.exports = {"cabecalho":"Telefones_cabecalho__aqOM7","opcoes":"Telefones_opcoes__2EVw_","botao":"Telefones_botao__2ZLgY"};